import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LocalStorageUtils } from "../helpers/LocalStorage";
import { ProfileJobCriteriaType } from "../interfaces/user";
import { BASE_URL } from "../constants/stringConstants";

export const jobsApi = createApi({
  reducerPath: "jobs",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set("Accept", "application/json");
      // headers.set("Content-Type", "multipart/form-data");
      const token = LocalStorageUtils.getItem("auth_token");
      if (token && endpoint !== "/auth/login" && endpoint !== "/auth/signup") {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getMatchedJobs: builder.mutation<{}, any>({
      query: ({ param, filterObj }) => ({
        url: `candidates/${param}/matched-candidates?filter=${filterObj}`,
        method: "GET",
      }),
    }),

    getAppliedJobs: builder.mutation<{}, any>({
      query: ({ param, filterObj }) => ({
        url: `candidate/${param}/job-application?filter=${filterObj}`,
        method: "GET",
      }),
    }),

    getCompanyJobDetails: builder.mutation<any, any>({
      query: ({ param }) => ({
        url: `company-job/${param}`,
        method: "GET",
      }),
    }),

    getCandidateTestPassed: builder.mutation<any, any>({
      query: ({ userId, jobId }) => ({
        url: `candidate-passed-test/${userId}/${jobId}`,
        method: "GET",
      }),
    }),

    getCustomQuestions: builder.mutation<any, any>({
      query: ({ jobId }) => ({
        url: `company-jobs/${jobId}/custom-questions`,
        method: "GET",
      }),
    }),

    changeJobStatus: builder.mutation<any, any>({
      query: ({ userId, ...rest }) => ({
        url: `candidates/${userId}/job-applications`,
        method: "POST",
        body: rest,
      }),
    }),

    checkJobStatusIsApplied: builder.mutation<any, any>({
      query: ({ userId, filterObj }) => ({
        url: `candidate/${userId}/job-application?filter=${filterObj}`,
        method: "GET",
      }),
    }),

    getMatchedJobPercentage: builder.mutation<any, any>({
      query: ({ userId, filterObj }) => ({
        url: `candidates/${userId}/matched-candidates?filter=${filterObj}`,
        method: "GET",
      }),
    }),

    getCandidateSkills: builder.mutation<any, any>({
      query: ({ filterObj }) => ({
        url: `test-logs?filter=${filterObj}`,
        method: "GET",
      }),
    }),

    submitCandidateQuestionAnswers: builder.mutation<any, any>({
      query: ({ userId, data }) => ({
        url: `candidates/${userId}/job-applications`,
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetMatchedJobsMutation,
  useGetAppliedJobsMutation,
  useGetCompanyJobDetailsMutation,
  useChangeJobStatusMutation,
  useCheckJobStatusIsAppliedMutation,
  useGetCandidateTestPassedMutation,
  useGetCustomQuestionsMutation,
  useGetMatchedJobPercentageMutation,
  useGetCandidateSkillsMutation,
  useSubmitCandidateQuestionAnswersMutation,
} = jobsApi;

// 'https://123.123.123.123/goods/121'
